import { downloadCSV } from "../utils/csvDownload";

interface GroupedBySiteTypeAdminProps {
    emissionsData: any[];
    nonDetectsData: any[];
    belowThresholdData: any[];
    isLoading: boolean;
}

export const GroupedBySiteTypeAdmin = ({
    emissionsData,
    nonDetectsData,
    belowThresholdData,
    isLoading,
}: GroupedBySiteTypeAdminProps) => {
    return (
        <div className="h-full flex flex-col items-center justify-center p-8 space-y-4">
            <button
                onClick={() =>
                    downloadCSV(emissionsData, "emissions_by_site_type.csv")
                }
                disabled={isLoading || !emissionsData.length}
                className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed w-80"
            >
                {isLoading
                    ? "Loading..."
                    : "Download Emissions by Site Type (CSV)"}
            </button>
            <button
                onClick={() =>
                    downloadCSV(nonDetectsData, "nondetects_by_site_type.csv")
                }
                disabled={isLoading || !nonDetectsData.length}
                className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed w-80"
            >
                {isLoading
                    ? "Loading..."
                    : "Download Non-Detects by Site Type (CSV)"}
            </button>
            <button
                onClick={() =>
                    downloadCSV(
                        belowThresholdData,
                        "below_threshold_by_site_type.csv",
                    )
                }
                disabled={isLoading || !belowThresholdData.length}
                className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed w-80"
            >
                {isLoading
                    ? "Loading..."
                    : "Download Below Threshold by Site Type (CSV)"}
            </button>
        </div>
    );
};
